import { Space } from 'antd'
import { EditPanelFooterProps } from './types'
import CIMSButton from 'components/CIMSButton'

const EditPanelFooter = ({
  form,
  loading,
  hasChanges,
  handleOnValuesChange,
}: EditPanelFooterProps) => (
  <Space size="large" style={{ marginTop: '18px' }}>
    <CIMSButton
      type="primary"
      htmlType="submit"
      loading={loading}
      disabled={{
        disabled: !hasChanges,
        reason: 'no changes',
      }}
    >
      Save
    </CIMSButton>
    <CIMSButton
      loading={loading}
      disabled={{
        disabled: !hasChanges,
        reason: 'no changes',
      }}
      onClick={() => {
        form.resetFields()
        handleOnValuesChange({}, form.getFieldsValue())
      }}
    >
      Undo
    </CIMSButton>
  </Space>
)

export default EditPanelFooter
